import { RouterProvider } from 'react-router-dom'
import Routing from './Routes'

function App() {
  return (
    <RouterProvider router={Routing} />
  )
}

export default App
